var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachmentImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M2.2857 0C1.025 0 0 1.025 0 2.2857v11.4286C0 14.975 1.025 16 2.2857 16h11.4286C14.975 16 16 14.975 16 13.7143V2.2857C16 1.025 14.975 0 13.7143 0zm2.2857 2.8571a1.7142 1.7142 0 1 1 0 3.4285 1.7142 1.7142 0 0 1 0-3.4285m5.1429 4c.3 0 .575.1572.7321.4108l3.1429 5.1428a.867.867 0 0 1 .0178.8679c-.15.2714-.4392.4357-.75.4357H3.1429c-.3179 0-.6143-.1786-.7608-.4607a.859.859 0 0 1 .0572-.8857l2-2.8572a.857.857 0 0 1 .7036-.3643.857.857 0 0 1 .7035.3643l.9429 1.35L8.982 7.2714c.1572-.2535.4322-.4107.7322-.4107z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment-image.d6d483d215a34383855dc1fe1b988433.svg";